import { render, staticRenderFns } from "./BoardWriteComponent.vue?vue&type=template&id=568e288f&scoped=true&"
import script from "./BoardWriteComponent.vue?vue&type=script&lang=js&"
export * from "./BoardWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e288f",
  null
  
)

export default component.exports